module.exports = __webpack_public_path__ + "static/media/pn.0886c4f6.svg";